import React, {useEffect} from "react";
import {Box, Button, ButtonLink, Card, OpenExternalLinkIcon, PageState} from "@myob/myob-widgets";
import "./Common.css"
import error2 from "../assets/something-wrong.svg"
import logo from "../assets/Logo.svg"
import * as PropTypes from "prop-types";
import HelpUrls from '../HelpUrls'
import {redirectTo} from "./utils";
import {safeTrack} from "./telemetry/SegmentHelper";

const helpUrl = HelpUrls.GetHelpSettingUpBankUrl;

function ErrorViewV2({type, redirectUrl, redirectToHelpPage}) {
  useEffect(() => {
    safeTrack('errorPageShown', { type });
  }, [type]);

  const redirect = (redirectUrl) => {
    redirectTo(redirectUrl);
  }

  const errorTypes = {
    openBankingFinaliseError: {
      title: "Something went wrong",
      description: "Your bankfeed couldn't be connected. To try again, restart the connection process.",
      img: error2,
      alt: "open banking connection error",
      buttonText: "Retry bankfeed connection"
    },
    openBankingErrorCallRetryable: {
      title: "Something went wrong",
      description: "Your bankfeed couldn't be connected. To try again, restart the connection process.",
      img: error2,
      alt: "open banking connection error",
      buttonText: "Retry bankfeed connection"
    },
    openBankingFinalisedRetryError: {
      title: "Bank connection unsuccessful",
      description: "To connect another account, restart the connection process.",
      img: error2,
      alt: "open banking finalised retry error",
      buttonText: "Retry bankfeed connection"
    },
    openBankingOnboardedRetryError: {
      title: "You're good to go",
      description: "To review your connection, return to the banking hub.",
      img: error2,
      alt: "open banking onboarded retry error",
      buttonText: "Back to Banking Hub"
    },
  }
  const isDesktop = window.innerWidth > 768;

  function getPageState() {
    return <PageState
      className={'img-block'}
      title={errorTypes[type].title}
      image={<img src={errorTypes[type].img}
                  alt={errorTypes[type].alt}/>}
      description={
        <React.Fragment>
          {errorTypes[type].description}
        </React.Fragment>
      }
      actions={[redirectUrl && (<Button
        className="redirect-from-error-page"
        style={{marginBottom: '20px'}}
        onClick={() => redirect(redirectUrl)}
        tone="brand"
        variant="standard"
      >
        {errorTypes[type].buttonText}
      </Button>)
      ]}
    >
    </PageState>;
  }

  return (
    <div className = 'page-block'>
      <Card size={'xxl'}>
        {isDesktop && <img src={logo} alt="logo" style={{width: '94px'}}/>}
        {getPageState()}
      </Card>
      {helpUrl && (<Box style={{textAlign: 'left'}}>
        <ButtonLink onClick={() => redirectToHelpPage("error")}
                    icon={<OpenExternalLinkIcon/>}
                    tone="info"
                    iconRight>
          Get help setting up a bank connection
        </ButtonLink>
      </Box>)}
    </div>
  );
}

ErrorViewV2.propTypes = {
  redirectUrl: PropTypes.string,
  type: PropTypes.string,
  redirectToHelpPage: PropTypes.func
}

export default ErrorViewV2;
